import * as yup from 'yup';
import { passwordSchema } from '../../../../utils/validation';

const rules = yup.object({
  currentPassword: passwordSchema(),
  newPassword: passwordSchema(),
});

export default rules;
